import { defineComponent as n, useSlots as c, openBlock as t, createElementBlock as o, mergeProps as i, unref as a, renderSlot as r, createCommentVNode as l, createElementVNode as f } from "vue";
import "./ghl-ui.es251.js";
import "./ghl-ui.es252.js";
import p from "./ghl-ui.es174.js";
const m = {
  key: 0,
  class: "hl-card-header"
}, u = { class: "hl-card-content" }, h = {
  key: 1,
  class: "hl-card-footer"
}, _ = n({
  name: "UICard",
  inheritAttrs: !1
}), v = n({
  ..._,
  props: {
    borderType: {
      type: [String, Boolean],
      default: !1
    }
  },
  setup(s) {
    const d = c();
    return (e, y) => (t(), o("div", i(e.$attrs, {
      class: ["hl-card", s.borderType ? `hl-${s.borderType}` : ""]
    }), [
      a(d).header ? (t(), o("div", m, [
        r(e.$slots, "header", {}, void 0, !0)
      ])) : l("", !0),
      f("div", u, [
        r(e.$slots, "default", {}, void 0, !0)
      ]),
      a(d).footer ? (t(), o("div", h, [
        r(e.$slots, "footer", {}, void 0, !0)
      ])) : l("", !0)
    ], 16));
  }
}), B = /* @__PURE__ */ p(v, [["__scopeId", "data-v-4dea884c"]]);
export {
  B as default
};
